import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderEl = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="ΑΠΑΙΤΗΣΤΕ ΤΟ ΜΠΟΝΟΥΣ ΣΑΣ"
            highlights={[
                { word: 'ΑΠΑΙΤΗΣΤΕ' },
                { word: 'ΤΟ' },
                { word: 'ΜΠΟΝΟΥΣ' },
                { word: 'ΣΑΣ' },
            ]}
            breakAfterWords={isDesktop ? [] : ['ΤΟ']}
            className={common.text_header}
        />
    )
}

export const TextLandEl = () => {
    return (
        <HighlightedText
            text="μπόνους 325% + 400 δωρεάν περιστροφές"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakBeforeWords={['δωρεάν']}
            className={styles.text_content}
        />
    )
}
